export enum CompletedStatus {
  Open = 'open',
  Completed = 'completed',
  Canceled = 'canceled',
  OnHold = 'on_hold',
  DidNotSign = 'did_not_sign'
}
